/**
 * Created by rickborst on 18/07/2017.
 */

import {getInstance as getDataSources} from 'datasources';
import {
    hideModal,
    setStatus as setModalStatus,
    ModalStatus
} from 'store/actions/modal';

const ActionTypes = {
        SET_FORGOT_PASSWORD_STATUS: 'SET_FORGOT_PASSWORD_STATUS',
        SET_FORGOT_PASSWORD_ERROR: 'SET_FORGOT_PASSWORD_ERROR'
    },

    ForgotPasswordStates = {
        INITIAL: 'INITIAL',
        REQUESTING_RESET: 'REQUESTING_RESET',
        REQUEST_FAILED: 'REQUEST_FAILED',
        REQUEST_SUCCESS: 'REQUEST_SUCCESS'
    };

/**
 * Sets the modal status.
 *
 * @param {string} status - Modal status.
 * @returns {Object} Action object.
 */
function setStatus (status) {

    return {
        type: ActionTypes.SET_FORGOT_PASSWORD_STATUS,
        status: status
    };
}

/**
 * Sets the modal error.
 *
 * @param {string|null} error - Error or null.
 * @returns {Object} Action object.
 */
function setSubmitError (error) {

    return {
        type: ActionTypes.SET_FORGOT_PASSWORD_ERROR,
        error: error
    };
}

/**
 * Ask for a link to reset the password.
 *
 * @param {string} email - E-mail of the user.
 * @returns {Function} Function that returns a promise
 * resolving to response to reset password call.
 */
function resetPassword (email) {

    return (dispatch) => {
        let dataSources = getDataSources();

        dispatch(setModalStatus(ModalStatus.LOADING));

        return dataSources.resetPassword(email)
            .then(() => {
                dispatch(setSubmitError(null));
                dispatch(setStatus(ForgotPasswordStates.INITIAL));
                dispatch(setModalStatus(ModalStatus.HIDE));
                dispatch(hideModal());
            }).catch((error) => {

                // dispatch(setSubmitError('asdasdasd'));
                dispatch(setStatus(ForgotPasswordStates.INITIAL));

                // dispatch(hideModal());

                return Promise.reject(error);
            });
    };
}

export {
    setStatus,
    setSubmitError,
    resetPassword,
    ActionTypes,
    ForgotPasswordStates
};


// WEBPACK FOOTER //
// ./src/js/store/actions/modals/forgotpassword.js